import PropTypes from "prop-types"
import { VpnKey } from "@mui/icons-material"
import { connect } from "react-redux"
import { get } from "lodash"
import Header from "modules/home-header"

function ResourceTokensHeader({ account, name }) {
  const resourceName = name ? `Resource Permissions: ${name}` : "Resource Permissions"
  return <Header Icon={VpnKey} title={resourceName} account={account} />
}

ResourceTokensHeader.propTypes = {
  account: PropTypes.string.isRequired,
  name: PropTypes.string,
}

export default connect(state => ({ name: get(state, "global.data.resourceTokens.data.resource.name") }), null)(ResourceTokensHeader)
